/**
 * Where a split job lives: inside its split major job in Automations. The
 * old Splitting Tools page kept /splitting-tools/:jobId; links of that shape
 * (Slack cards, toasts saved in the browser) are redirected here.
 */
import type { PdfJobBase } from "features/pdfTools/pdfTools";

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isSplitJobId(value: string | null | undefined): value is string {
  return typeof value === "string" && UUID_RE.test(value);
}

export function majorJobPath(
  userId: number | string,
  majorJobId: number | string,
  tab?: string,
): string {
  return `/bots-management/${userId}/major-job/${majorJobId}${tab ? `?tab=${tab}` : ""}`;
}

export function splitJobPath(
  userId: number | string,
  majorJobId: number | string,
  jobId: string,
  tab?: string,
): string {
  return `${majorJobPath(userId, majorJobId)}/split-job/${jobId}${tab ? `?tab=${tab}` : ""}`;
}

export function legacySplitJobPath(jobId: string): string {
  return `/splitting-tools/${jobId}`;
}

/** A tracked job or a toast: its own address when its ids are known, else the
 * redirect that looks them up. */
export function splitJobPathFor(ref: {
  jobId: string;
  userId?: number | null;
  majorJobId?: number | null;
}): string {
  if (ref.userId != null && ref.majorJobId != null) {
    return splitJobPath(ref.userId, ref.majorJobId, ref.jobId);
  }
  return legacySplitJobPath(ref.jobId);
}

/** Where a loaded job belongs. */
export function splitJobPathForPayload(
  job: Pick<PdfJobBase, "job_id" | "user" | "major_job">,
): string {
  if (job.user.id != null && job.major_job) {
    return splitJobPath(job.user.id, job.major_job.id, job.job_id);
  }
  return job.user.id != null ? `/bots-management/${job.user.id}` : "/bots-management";
}
